import React, { createContext } from "react";
import { useInterpret } from "@xstate/react";
import { audioPlayerMachine } from "./audioPlayerMachine";
import { interpret } from "xstate";

const initialAudioPlayerService = interpret(audioPlayerMachine);

export type AudioPlayerService = typeof initialAudioPlayerService;

export const AudioPlayerMachineContext = createContext({
  audioPlayerService: initialAudioPlayerService,
});

type Props = {
  children: React.ReactNode;
  service?: AudioPlayerService;
};

export default function AudioPlayerMachineProvider(props: Props) {
  const audioPlayerService = useInterpret(audioPlayerMachine);

  return (
    <AudioPlayerMachineContext.Provider
      value={{ audioPlayerService: props.service ?? audioPlayerService }}>
      {props.children}
    </AudioPlayerMachineContext.Provider>
  );
}
